import { createAction } from 'redux-actions'

const ns = 'notification/'

export const addNotification = createAction(`${ns}ADD_NOTIFICATION`)
export const clearNotification = createAction(`${ns}CLEAR_NOTIFICATION`)
